import React from 'react';
import styled from 'styled-components/macro';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import {
  renderField,
  renderCheckBoxTermsField,
  renderSelectField,
  renderDigitField,
  renderError,
} from '../../../form_helpers';
import { isCompetition, IsvgWrapper } from '../../../helpers';
import {
  MAIL_LIST_ON_SIGNUP,
  NONE_FORM_VALUE,
  MALE_FORM_VALUE,
  FEMALE_FORM_VALUE,
  OTHER_FORM_VALUE,
  PREFER_NOT_FORM_VALUE,
  EN_FORM_VALUE,
  CY_FORM_VALUE,
} from '../../../constants';
import Isvg from 'react-inlinesvg';
import arrow_back from '../../../img/icons/arrow_back.svg';
import validate from './SignUpFormValidate';
import { Button as ButtonV2 } from '../../../v2/components/button/Button';

let SignUpForm2 = (props) => {
  const strings = props.strings;

  const { handleSubmit, submitting, pristine, passBreach } = props;
  const genders = [
    [strings.selectString, NONE_FORM_VALUE],
    [strings.male, MALE_FORM_VALUE],
    [strings.female, FEMALE_FORM_VALUE],
    [strings.other, OTHER_FORM_VALUE],
    [strings.preferNot, PREFER_NOT_FORM_VALUE],
  ];

  const lang = props.curLang && props.curLang === 1 ? 1 : 0;

  return (
    <div className="form form--no-btm-pad">
      <header className="form__header">
        <FormInstruct>{strings.registerInstruction2}</FormInstruct>
      </header>
      <form className="form__form" onSubmit={handleSubmit}>
        <Field
          name="gender"
          type="select"
          component={renderSelectField}
          extraClass={'form__col1'}
          label={strings.gender}
          helpText="Date"
          optional={true}
          strings={strings}
        >
          {genders.map((genderOption) => (
            <option value={genderOption[1]} key={genderOption[1]}>
              {genderOption[0]}
            </option>
          ))}
        </Field>

        <Field
          name="postcode"
          type="text"
          component={renderField}
          placeholder={strings.postCode}
          label={strings.postCode}
          extraClass={'form__col2'}
          optional={true}
          strings={strings}
        />

        <Field
          name="preferred_language_iso_code"
          type="select"
          component={renderSelectField}
          label={strings.prefLanguage}
        >
          {lang === 0 && (
            <optgroup>
              <option value={CY_FORM_VALUE}>{strings.welsh}</option>
              <option value={EN_FORM_VALUE}>{strings.english}</option>
            </optgroup>
          )}

          {lang === 1 && (
            <optgroup>
              <option value={EN_FORM_VALUE}>{strings.english}</option>
              <option value={CY_FORM_VALUE}>{strings.welsh}</option>
            </optgroup>
          )}
        </Field>

        <DateOfBirth>
          <FormRow>
            <h4 className="form__label">{strings.dob}</h4>
            <span>({strings.optional})</span>
          </FormRow>
          <Field
            name="day"
            type="number"
            component={renderDigitField}
            label="Day"
            placeholder={strings.dd}
            maxLen={2}
            extraClass="form__field--2-digit"
          />
          <Field
            name="month"
            type="number"
            component={renderDigitField}
            label="Month"
            placeholder={strings.mm}
            maxLen={2}
            extraClass="form__field--2-digit"
          />
          <Field
            name="year"
            type="number"
            component={renderDigitField}
            label="Year"
            placeholder={strings.yyyy}
            maxLen={4}
            extraClass="form__field--4-digit"
          />
          <Field name="dateError" component={renderError} />
        </DateOfBirth>

        <div className="form__checkbox-holder form__checkbox-holder--no-padding">
          <Field
            name={MAIL_LIST_ON_SIGNUP}
            type="checkbox"
            component={renderCheckBoxTermsField}
            label={strings.mailingLists[0]}
            on={strings.yes}
            off={strings.no}
          />
        </div>

        <div className="form__checkbox-holder form__checkbox-holder--no-padding">
          <Field
            name="terms_accepted"
            type="checkbox"
            component={renderCheckBoxTermsField}
            label={strings.registerConfirm}
            on={strings.yes}
            off={strings.no}
          />
        </div>

        {props.children}

        {isCompetition() && (
          <div
            className="form__comp"
            dangerouslySetInnerHTML={{ __html: strings.competitionMessage }}
          ></div>
        )}

        {passBreach && passBreach.foundLine && (
         <div role="alert" className="form__suggestion">
          <div
            className="form__suggest"
            dangerouslySetInnerHTML={{
              __html: `<span class="suggest__msg">${
                strings.pwnedPasswordMessage
              } </span>`,
            }}
          />
       </div>
        )}

        <FormActions>
          <div>
            <button
              type="button"
              className="form__back link"
              onClick={props.previousPage}
            >
              <IsvgWrapper addClasses='icon'>
                <Isvg src={arrow_back} />
              </IsvgWrapper> {strings.back}
            </button>
          </div>
          <div>
            <ButtonV2
              onClick={handleSubmit}
              label={strings.signUp}
              size="large"
              disabled={pristine || submitting}
            />
            <ButtonSubmit aria-hidden="true" />
          </div>
        </FormActions>
      </form>
    </div>
  );
};

const FormInstruct = styled.div`
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.theme.color.blackFull
      : props.theme.color.whiteFull};
  font-size: 20px;
  line-height: 24px;
`;

const DateOfBirth = styled.div`
  position: relative;
  .form__error {
    top: -14px;
    left: 20px;
    @media screen and (min-width: 645px) {
      top: 73px;
      left: calc(100% - 22px);
    }
  }
`;

const FormRow = styled.div`
  display: flex;
  margin: 0 20px;
  flex-direction: row;
  align-items: center;
  h4 {
    margin: 0 6px 0 0;
  }
  span {
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.black90
        : props.theme.color.white90};
    font-size: 16px;
    line-height: 19px;
    text-transform: lowercase;
  }
  ~ .form__field {
    margin-top: 6px;
  }
`;

const FormActions = styled.div`
  display: flex;
  margin: 11px 20px 30px;
  align-items: center;

  .link {
    position: relative;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.black90
        : props.theme.color.white90};
    font-size: 18px;
    font-weight: bold;
    line-height: 27px;
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      border-radius: 4px;
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
    &:after {
      position: absolute;
      width: calc(100% - 30px);
      right: 0;
      bottom: 4px;
      border-width: 0 0 1px;
      border-style: solid;
      content: '';
    }
    span {
      margin-right: 10px;
    }
    svg {
      fill: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
  }

  > div:last-of-type {
    margin-left: 3.2em;
  }
`;

const ButtonSubmit = styled.button`
  position: absolute;
  left: -9999px;
`;

SignUpForm2 = reduxForm({
  form: 'signup',
  destroyOnUnmount: false,
  enableReinitialize: true,
  validate,
})(SignUpForm2);

SignUpForm2 = connect(
  (state) => ({
    passBreach: state.passBreach.success
  })
)(SignUpForm2);

export default SignUpForm2;